import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import LogoMark from "@/components/LogoMark";
import { toast } from "sonner";

export default function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const loc = useLocation();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setLoading(true);
        const res = await login(email, password);
        setLoading(false);
        if (!res.ok) {
            setErr(res.error);
            return;
        }
        toast.success("Welcome back.");
        const dest = res.user.role === "admin" ? "/admin" : (loc.state?.from || "/portal");
        nav(dest, { replace: true });
    };

    return (
        <div className="min-h-[80vh] flex items-center justify-center px-6 py-16" data-testid="login-page">
            <div className="w-full max-w-md">
                <div className="flex justify-center mb-8"><LogoMark size={56} /></div>
                <div className="bg-ink-800 border border-white/10 rounded-2xl p-8">
                    <div className="label-tag">Portal access</div>
                    <h1 className="mt-3 font-display text-3xl font-bold">Sign in to your account.</h1>
                    <form onSubmit={submit} className="mt-8 space-y-5" data-testid="login-form">
                        <label className="block">
                            <span className="block text-xs tracking-[0.2em] uppercase text-white/60 mb-2">Email</span>
                            <input type="email" required data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-ink-900 border border-white/15 rounded-lg px-4 py-3" />
                        </label>
                        <label className="block">
                            <span className="block text-xs tracking-[0.2em] uppercase text-white/60 mb-2">Password</span>
                            <input type="password" required data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-ink-900 border border-white/15 rounded-lg px-4 py-3" />
                        </label>
                        {err && <div className="text-sm text-red-400" data-testid="login-error">{err}</div>}
                        <button
                            type="submit"
                            disabled={loading}
                            data-testid="login-submit-btn"
                            className="w-full px-7 py-3.5 rounded-full bg-gold-500 text-ink-900 font-bold uppercase tracking-wider text-sm hover:bg-gold-400 disabled:opacity-60"
                        >
                            {loading ? "Signing in…" : "Sign in"}
                        </button>
                    </form>
                    <p className="mt-6 text-sm text-white/60 text-center">
                        New here? <Link to="/register" data-testid="login-register-link" className="text-gold-500">Create a union account</Link>
                    </p>
                </div>
            </div>
        </div>
    );
}
